<div class="mapContent">
    <!-- <app-map fxFlex> </app-map> -->
    <app-source-map></app-source-map>
  
</div>

<div class="attributeContent" >
    <div #attributeTable></div>
</div>
<div class="chartContent">
    <h2 style="text-align: center;">Parcel Charts</h2>
    <div class="canva row">
        <div class="col-lg-3"><canvas id="MyChart1"></canvas></div>
        <div class="col-lg-3"><canvas id="MyChart2"></canvas></div>
        <div class="col-lg-3"><canvas id="MyChart3"></canvas></div>
        <div class="col-lg-3"><canvas id="MyChart4"></canvas></div>
    </div>
    </div>